
/**
 * Very simple timer to be used to keep track of various activities.
 * Note that this doesn't have any associated UI for it and should
 * be utilized in simple use cases only.
 */
export class SimpleTimer {
  startedTime: number
  lastLapsedTime: number

  constructor() {
    let now = Date.now()

    this.startedTime = now
    this.lastLapsedTime = now
  }

  start() {
    let now = Date.now()

    this.startedTime = now
    this.lastLapsedTime = now
  }

  reset() {
    this.start()
  }

  resetLapse() {
    this.lastLapsedTime = Date.now()
  }

  diffInMilliSeconds() {
    return Date.now() - this.startedTime
  }

  diffInSeconds() {
    return Math.round(this.diffInMilliSeconds()/1000)
  }

  lapsedDiffInMilliSeconds() {
    let now = Date.now()
    let diff = now - this.lastLapsedTime

    this.lastLapsedTime = now

    return diff
  }

  lapsedDiffInSeconds( ){
    return Math.round(this.lapsedDiffInMilliSeconds()/1000)
  }
}
